import {
  DEFAULT_LANGUAGE,
  LocalizedText,
  TRANSLATION_LANGUAGES,
} from 'apollo/localizedTypes';

const normalize = (value?: string | null): string | null => value?.trim() || null;

const mapLocalizedText = (value?: LocalizedText): LocalizedText => {
  const translations = TRANSLATION_LANGUAGES.reduce(
    (mapped, language) => ({ ...mapped, [language]: normalize(value?.[language]) }),
    {}
  );

  return {
    ...translations,
    [DEFAULT_LANGUAGE]: value?.[DEFAULT_LANGUAGE] || '',
  } as LocalizedText;
};

export default mapLocalizedText;
